'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
require('react');
var withIconProps = require('../../../../withIconProps-365ff8d5.js');
var react = require('@emotion/react');
require('@babel/runtime/helpers/objectWithoutProperties');
require('@babel/runtime/helpers/taggedTemplateLiteral');
require('@styled-system/should-forward-prop');
require('styled-system');
require('@emotion/styled');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);

var SvgComponent = function SvgComponent(props) {
  return react.jsx("svg", _extends__default["default"]({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), react.jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17 2a6 6 0 0 0-5 2.686A6 6 0 0 0 7 2C3.692 2 1 4.691 1 8a5.97 5.97 0 0 0 1.233 3.633L10.709 22h2.583l8.5-10.399A5.942 5.942 0 0 0 23 8c0-3.309-2.691-6-6-6"
  }));
};
var Component = withIconProps.withIconProps(SvgComponent);

exports["default"] = Component;
//# sourceMappingURL=Like.js.map
